import React, { useEffect, useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import Button from '../../components/shared/buttons/button';
import { showToast } from '../../helpers/Utils';
import { useHelpMutation, useGetHelpRequestsQuery } from '../../app/userApi/userApi';
import InputWithLabel from '../../components/shared/fields/InputWithLabel';

const Help = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [submitHelp, { isLoading }] = useHelpMutation();
  const { data: helpData, isSuccess } = useGetHelpRequestsQuery();

  useEffect(() => {
    if (isSuccess && helpData?.data) {
      setTitle(helpData.data.title || '');
      setContent(helpData.data.content || '');
    }
  }, [helpData, isSuccess]);

  const handleChange = (value) => {
    setContent(value);
  };

  const handleSubmit = async () => {
    if (!title.trim()) {
      showToast('Please enter a title.', 'error');
      return;
    }

    if (!content || content.trim() === '<p><br></p>') {
      showToast('Please enter some help content.', 'error');
      return;
    }

    try {
      await submitHelp({ title, content }).unwrap();
      showToast('Help request submitted successfully!', 'success');
    } catch (error) {
      showToast(error?.data?.message || 'Failed to submit help request.', 'error');
    }
  };

  return (
    <div className="container mt-4">
      <h3>Help / Feedback</h3>

      <InputWithLabel
        label="Title"
        placeholder="Enter your help request title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="mb-3"
      />

      <div className="mb-3">
        <ReactQuill
          value={content}
          onChange={handleChange}
          placeholder="Write your message..."
        />
      </div>

      <Button label={isLoading ? 'Submitting...' : 'Submit'} onClick={handleSubmit} />

      {/* {content && (
        <>
          <h5 className="mt-4">Preview:</h5>
          <div className="p-3 border" dangerouslySetInnerHTML={{ __html: content }} />
        </>
      )} */}
    </div>
  );
};

export default Help;
